export enum ETelemetryEventType {
  /* На экране появился попап с окном ввода номера телефона */
  onPhoneScreenShown = 'phoneScreenShown',
  /* На экране появился попап с окном ввода кода из СМС */
  onCodeScreenShown = 'codeScreenShown',
  /* Успешная авторизация */
  AuthSuccess = 'authSuccess',
  /* Нет манифеста ипотечного калькулятора или ошибка рендера (Error Boundary) */
  OfferCalculatorRenderError = 'offerCalculatorRenderError',
  /* Показ пустой выдачи предложений после завершения загрузки */
  EmptyOffersListingShown = 'emptyOffersListingShown',
}
